import _ from 'lodash';

import {
  PROPERTY_TYPES_CODES,
  PROPERTY_TYPES_LABELS,
} from 'go/components/dynamic/modules/projectSiteInventory/constants';

export const isLocationBuildingInventoryType = (locationType) => {
  return (
    _.toLower(locationType) === _.toLower(PROPERTY_TYPES_CODES.BUILDING) ||
    _.toLower(locationType) === _.toLower(PROPERTY_TYPES_LABELS.BLDG)
  );
};

export const isLocationInfrastructureInventoryType = (locationType) => {
  return (
    _.toLower(locationType) === _.toLower(PROPERTY_TYPES_CODES.INFRASTRUCTURE) ||
    _.toLower(locationType) === _.toLower(PROPERTY_TYPES_LABELS.INFRA)
  );
};

export const isVacantLandInventoryType = (locationType) => {
  return (
    _.toLower(locationType) === _.toLower(PROPERTY_TYPES_CODES.VACANTLAND) ||
    _.toLower(locationType) === _.toLower(PROPERTY_TYPES_LABELS.VACLAND)
  );
};

export const getOptionText = (options, code) => {
  const getText = (code) => {
    return _.chain(options)
      .find((option) => (option.value ? option.value === code : option.text === code))
      .get('text')
      .value();
  };
  if (_.isArray(code)) {
    let texts = [];
    _.each(code, (c) => {
      texts.push(getText(c));
    });
    return _.join(texts, ', ');
  } else {
    return getText(code);
  }
};
